<div class="wrapper" [ngClass]="{ hideBar: !stateName }">
    <div class="container">
        <div class="main-nav">
            <div *ngIf="stateName" class="for-educators-notice">For {{ stateName }} Educators</div>
            <div class="buttons-group-wrapper">
                <div class="subjects-selector-opener-wrapper">
                    <button
                        class="selenium-navigation-subjects-selector"
                        [ngStyle]="{
                            'background-color':
                                isSubjectsPanelOpened === true ? '#0a145a' : 'transparent'
                        }"
                        (click)="toggleSubjectsPanel()"
                    >
                        Subjects
                        <div [class]="isSubjectsPanelOpened ? 'arrow-up' : 'arrow-down'"></div>
                    </button>
                    <div *ngIf="isSubjectsPanelOpened" class="arrow-indicator"></div>
                </div>
                <div class="grades-selector-wrapper">
                    <button
                        class="selenium-navigation-grades-selector"
                        [ngStyle]="{
                            'background-color':
                                isGradesPanelOpened === true ? '#0a145a' : 'transparent'
                        }"
                        (click)="toggleGradesPanel()"
                    >
                        Grades
                        <div [class]="isGradesPanelOpened ? 'arrow-up' : 'arrow-down'"></div>
                    </button>
                    <ng-container *ngIf="isGradesPanelOpened">
                        <div class="arrow-indicator"></div>
                        <div class="grades-panel" (mouseleave)="isGradesPanelOpened = false">
                            <button
                                class="gtm-navigation-grades-selector"
                                *ngFor="let gradeBand of GRADE_BANDS"
                                [attr.data-gtmlabel]="gradeBand.gtmLabel"
                                (click)="navigateToGradeBand(gradeBand)"
                            >
                                {{ gradeBand.label }}
                            </button>
                        </div>
                    </ng-container>
                </div>
                <button
                    class="selenium-navigation-browse-standards"
                    (click)="router.navigate(['/standards/0/'])"
                >
                    Standards
                </button>
                <a
                    class="for-students py-2 px-7"
                    href="/student/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    For Students
                    <em class="fas fa-external-link-alt"></em>
                </a>
            </div>
        </div>
    </div>
    <div class="subjects-panel">
        <div
            class="container subjects-wrapper"
            *ngIf="isSubjectsPanelOpened"
            (mouseleave)="isSubjectsPanelOpened = false"
        >
            <div class="subject-frame" *ngFor="let subject of subjects">
                <button
                    class="parent-subject gtm-navigation-discipline"
                    [attr.data-gtmlabel]="subject.title"
                    [ngStyle]="{
                        color: getSubjectColor(subject.id)
                    }"
                    (click)="
                        router.navigate(['/subjects/' + subject.slug]);
                        isSubjectsPanelOpened = false
                    "
                >
                    {{ subject.title }}
                </button>
                <button
                    class="child-subject gtm-navigation-subject-child"
                    [attr.data-gtmlabel]="child.title"
                    *ngFor="let child of getAvailableSubjects(subject)"
                    (click)="router.navigate([child.getBrowseURL()]); isSubjectsPanelOpened = false"
                >
                    {{ child.title }}
                </button>
            </div>
        </div>
    </div>
</div>
